import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";

import "./PublicContainer.scss";
import { LogoIconDarkText } from "../../common/components/core/icons";

type PublicContainerProps = {
    children: React.ReactNode;
};

const PublicContainer = ({ children }: PublicContainerProps): JSX.Element => {
    return (
        <Container fluid>
            <Row className="login-header-main">
                <StyledLogoIcon />
            </Row>
            <main>
                <Row className="login-main">
                    <Col className="vh-100 login-right position-relative login-left-box">
                        {children}
                    </Col>
                </Row>
            </main>
        </Container>
    );
};

const StyledLogoIcon = styled(LogoIconDarkText)`
    width: 200px;
`;

export default PublicContainer;
